var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-main"},[_c('router-view',{on:{"ChangeColor":_vm.ChangeColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }